import {AutocompleteLoadingModeType, IAutocompleteSchema, ToastService} from "maps-angular-components";
import {Component, EventEmitter, OnDestroy, OnInit, Output,} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {Subject, Subscription} from "rxjs";

import {AutocompleteItem} from "../../shared/models/autocomplete.model";
import {Carteira} from "../carteira.model";
import {CarteiraService} from "../carteira.service";
import {MaskUtil} from "../../shared/util/mask-util";
import {PageableCarteiraFilter} from "../pageable-carteira-filter";
import {PaginationResponse} from "../../shared/form/pagination-response";
import {SimNaoOptions} from "../../shared/util/select-utils";
import {indicate} from "../../shared/util/loading-indicate";
import {CarteiraCnpjService} from "../carteira.cnpj.service";
import {CarteiraCNPJ} from "../carteira.cnpj.model";
import {BrowserSupport} from "../../shared/util/browser-support";

@Component({
    selector: "app-carteira-pesquisa",
    templateUrl: "./carteira-pesquisa.component.html",
    styleUrls: ["./carteira-pesquisa.component.scss"],
})
export class CarteiraPesquisaComponent implements OnInit, OnDestroy {
    private readonly subscriptions = new Subscription();

    form: FormGroup;
    nomeCompleto: string;
    nome: string;

    loading$ = new Subject<boolean>();
    loadingExport$: Subject<boolean> = new Subject<boolean>();
    showExecutar = false;

    private data: Carteira[];
    private pageSize = 20;
    private pageNumber = 1;

    @Output() dataFetched = new EventEmitter<PaginationResponse>();

    @Output() searchEvent = new EventEmitter<number>();

    @Output() filterChanged = new EventEmitter<PageableCarteiraFilter>();

    nomeAutocompleteDatasource: Subject<AutocompleteItem[]> = new Subject();
    nomeCompletoAutocompleteDatasource: Subject<AutocompleteItem[]> = new Subject();

    opcoesAtivaEnquadramento: any[] = SimNaoOptions.values;
    opcoesProcAuto: any[] = SimNaoOptions.values;

  nomeSchema: IAutocompleteSchema<CarteiraCNPJ>;
  nomeCompletoSchema: IAutocompleteSchema<CarteiraCNPJ>;


  constructor(
    private readonly carteiraService: CarteiraService,
    private readonly carteiraCnpjService: CarteiraCnpjService,
    private readonly messageService: ToastService) {}

    ngOnInit() {
        this.form = new FormGroup({
            nome: new FormControl(this.nome),
            nomeCompleto: new FormControl(this.nomeCompleto),
            ativa: new FormControl(""),
            auto: new FormControl(""),
        });

        this.nomeSchema = {
            service: this.carteiraCnpjService,
            label: "Nome",
            placeholder: "Nome da carteira",
            loadingMode: AutocompleteLoadingModeType.LAZY,
            autoload: false,
            endpoint: "ativo/nome",
            formGroup: this.form,
            formControlName: "nome",
            panelClass: "w-100",
            parseSearchParam(search): string {
                return search;
            },
        };
        this.nomeCompletoSchema = {
            service: this.carteiraCnpjService,
            label: "Nome completo",
            placeholder: "Nome da carteira",
            loadingMode: AutocompleteLoadingModeType.LAZY,
            autoload: false,
            endpoint: "ativo/nomecompleto",
            formGroup: this.form,
            formControlName: "nomeCompleto",
            panelClass: "w-100",
            parseSearchParam(search): string {
                return search;
            },
        };
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    btnPesquisar() {
        this.pageNumber = 1;
        this.pesquisar();
        this.searchEvent.emit(this.pageNumber);
    }

    pesquisar() {
        this.nome = this.form.value.nome;
        this.nomeCompleto = this.form.value.nomeCompleto; // auto complete input

        this.fetchPage(
            this.nome,
            this.nomeCompleto,
            this.form.value.ativa,
            this.form.value.auto
        );
    }

    nextPage(pageNumber: number) {
        this.pageNumber = pageNumber;
        this.pesquisar();
    }

    updatePageSize(pageSize: number) {
        this.pageSize = pageSize;
        this.pageNumber = 1;
        this.pesquisar();
    }

    fetchPage(nome, nomeCompleto, ativa, auto) {
        this.showExecutar = true;
        const filter = new PageableCarteiraFilter(this.pageSize, this.pageNumber - 1, nome, nomeCompleto, ativa, auto);
        this.filterChanged.emit(filter);
        this.subscriptions.add(
            this.carteiraService.findFromEnquadramentoEAtivoPaginado(filter).pipe(
                indicate(this.loading$)
            ).subscribe(
                (page) => {
                    this.data = page.content;
                    this.dataFetched.emit(page);
                },
                err => {
                    this.messageService.erro(err.error.message);
                }
            )
        );
    }

    buscarDadosAutocompleteNome(searchString: string) {
        const itens: AutocompleteItem[] = [];
        this.data.filter(carteira => carteira.nome
        .includes(searchString.toUpperCase()) || carteira.cnpj.includes(searchString
        .replace(".", "")
        .replace(".", "")
        .replace("-", "")))
        .forEach(carteira => {
            itens.push({
                id: carteira.cnpj, name: carteira.nome.concat('(')
                .concat(MaskUtil.formatCnpj(carteira.cnpj))
                .concat(')')
            });
        });
        this.nomeAutocompleteDatasource.next(itens);
    }

  exportarPdf() {
    this.subscriptions.add(
      this.carteiraService.exportPdf(this.form.value).pipe(indicate(this.loadingExport$)).subscribe(data => {
        BrowserSupport.savePDF(data);
      }, err => this.messageService.erro(err.error.message)));
  }

  exportarXls() {
    this.subscriptions.add(
      this.carteiraService.exportXlsx(this.form.value).pipe(indicate(this.loadingExport$)).subscribe(data => {
        BrowserSupport.saveXlsx(data);
      }, err => this.messageService.erro(err.error.message)));
  }
}
